module.exports = __webpack_public_path__ + "static/media/api.c979b3b9.svg";